/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190402 by Jan Brunner
 *     all rights reserved.
 */

import { IMSObject, IMSId } from './ims-object';

export class Equipment extends IMSObject {
  static fromDto(dto: EquipmentDTO, databag?: any) {
    const obj = new this(
      {
        imsId: dto.id,
        secondaryId: dto.secondaryid,
        objRef: 'ims/Equipment'
      },
      dto.label,
      new IMSObject(dto.branch.id, undefined, dto.branch.label, 'ims/Branch'),
      dto.equipmentclass,
      dto.installationsite
    );

    if (databag) {
      obj.databag = databag
    } else {
      obj.databag = dto;
    }
    return obj;
  }

  constructor(
    public readonly id: IMSId,
    label: string,
    public branch: IMSObject,
    public equipmentclass: string = undefined,
    public installationsite: string = undefined
  ) {
    super(id.imsId, id.secondaryId, label, 'ims/Equipment');
  }
}

export interface EquipmentDTO {
  id: number;
  secondaryid: number;
  label: string;
  branch: {
    id: number;
    label: string;
  };
  equipmentclass: string;
  installationsite: string;
}
